//Action type for Transaction reducer 
export const Add_Country = "AddCountry";
export const Add_PayOutNetwork = "AddPayOutNetwork";
export const Add_Recipient = "AddRecipient";
export const Add_Card = "AddCard";
export const Add_RecipientRecieves = "AddRecipientRecieves"

//Action type for Fetch reducer
export const Fetch_Recipient = 'Fetch_Recipient';
export const Fetch_Recipient_Failure = 'Fetch_Recipient_Failure';
export const Fetch_Recipient_Success = 'Fetch_Recipient_Success';

export const Fetch_Card = 'Fetch_Card';
export const Fetch_Card_Failure = 'Fetch_Card_Failure';
export const Fetch_Card_Success = 'Fetch_Card_Success';

export const Fetch_User = 'Fetch_User';
export const Fetch_User_Failure = 'Fetch_User_Failure';
export const Fetch_User_Success = 'Fetch_User_Success';

export const Fetch_Rate = 'Fetch_Rate';
export const Fetch_Rate_Failure = 'Fetch_Rate_Failure';
export const Fetch_Rate_Success = 'Fetch_Rate_Success';

//Action type for Auth reducer
export const Add_User = 'Add_User';

